import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-newlayout-footer',
  templateUrl: './newlayout-footer.component.html',
  styleUrls: ['./newlayout-footer.component.scss']
})
export class NewlayoutFooterComponent implements OnInit {

  currentyear:Number;

  constructor() { }

  ngOnInit() {

    this.currentyear = new Date().getFullYear();
  }

}
